import { createAsyncThunk } from '@reduxjs/toolkit';
import * as queries from '../../../graphql/queries';
import { API, graphqlOperation } from "aws-amplify";

import { Auth } from "aws-amplify";

export const getShopList = createAsyncThunk('auth/login/getShopList', async (param) => {
  console.log('★thunk.js getShopList :' + param);

  //ログインしたアカウントのみが見れる店舗リストを取得
  const data = await Auth.currentUserInfo();
  const shopUUID = data.attributes.sub;
  console.log('shopUUID\n' + shopUUID)
  const res_t = await API.graphql(graphqlOperation(queries.getShopAccount20230722, { developerUuid: shopUUID }))
  //console.log('2店舗一覧HOGE1' + '\n' + JSON.stringify(res_t.data.getShopAccount20230722))
  var _data = Object.assign({}, { getShopAccount: res_t.data.getShopAccount20230722 });
  const res = Object.assign({}, { data: _data })

  //共通で全店舗見せる場合は下記(slice.jsの２９行目も修正する)
  //const res = await API.graphql(graphqlOperation(queries.getShopList))
  console.log('店舗一覧', res)

  return res

});


export const getSalesOverview = createAsyncThunk('auth/login/getSalesOverview', async (param) => {
  //console.log('★thunk.js getSalesOverview :' + param);//[object Object]
  //console.log('★thunk.js getSalesOverview JSON.stringify:' + '\n' + JSON.stringify(param));//JSON形式で見ると問題なさそう => {"shop_ids":[6,43,169],"fromDate":"2022-3-5","toDate":"2022-3-6"}

  ////const res = await API.graphql(graphqlOperation(queries.getSalesOverview({ shop_ids: [6, 43, 169], fromDate: '2022-3-5', toDate: '2022-3-6' })))
  ////const res = await API.graphql(graphqlOperation(queries.getSalesOverview(param)))
  //const res = await API.graphql(graphqlOperation(queries.getSalesOverview, { param }));

  //console.log('■4res : ' + '\n' + res);
  //console.log('■5店舗情報HOGE' + '\n' + JSON.stringify(res.data.getSalesOverview))
  //console.log('■6店舗情報HOGE' + '\n' + res.data.getSalesOverview)

  //return res

});


export const getPeriodSales = createAsyncThunk('auth/login/getPeriodSales', async (param) => {
});

export const getPeriodSalesDetail = createAsyncThunk('auth/login/getPeriodSalesDetail', async (param) => {
});

export const getSalesByTimezone = createAsyncThunk('auth/login/getSalesByTimezone', async (param) => {
});

export const getSalesByCategory = createAsyncThunk('auth/login/getSalesByCategory', async (param) => {
});

export const getSalesByProduct = createAsyncThunk('auth/login/getSalesByProduct', async (param) => {
});

export const getJournalList = createAsyncThunk('auth/login/getJournalList', async (param) => {
});

export const getJournal = createAsyncThunk('auth/login/getJournal', async (param) => {
});

export const getDailySumHistory = createAsyncThunk('auth/login/getDailySumHistory', async (param) => {
});
export const getMonthlySumHistory = createAsyncThunk('auth/login/getMonthlySumHistory', async (param) => {
});

export const getDailySum = createAsyncThunk('auth/login/getDailySum', async (param) => {
});
export const getMonthlySumVer2 = createAsyncThunk('auth/login/getMonthlySumVer2', async (param) => {
});
export const getVoidList = createAsyncThunk('auth/login/getVoidList', async (param) => {
});


export const getShopAccount = createAsyncThunk('auth/login/getShopAccount', async (param) => {
  //const data = await Auth.currentUserInfo();
  //console.log('▼data' + '\n' + JSON.stringify(data))
  //const shopUUID = data.attributes.sub;
  //console.log('★shopUUID:' + shopUUID)

});

export const getDailySumVer2 = createAsyncThunk('auth/login/getDailySumVer2', async (param) => {
});


export const getDeveloperAccount = createAsyncThunk('auth/login/getDeveloperAccount', async (param) => {
});

export const brandList = createAsyncThunk('auth/login/BrandList', async (param) => {
});

export const createBrand = createAsyncThunk('auth/login/createBrand', async (param) => {
});
export const updateBrand = createAsyncThunk('auth/login/updateBrand', async (param) => {
});
export const deleteBrand = createAsyncThunk('auth/login/deleteBrand', async (param) => {
});

export const getBrandByDeveloper = createAsyncThunk('auth/login/getBrandByDeveloper', async (param) => {
});
export const getStoreByDeveloper = createAsyncThunk('auth/login/getStoreByDeveloper', async (param) => {
});
export const updateStore = createAsyncThunk('auth/login/updateStore', async (param) => {
});
export const deleteStore = createAsyncThunk('auth/login/deleteStore', async (param) => {
});

export const getGenreList = createAsyncThunk('auth/login/getGenreList', async (param) => {
});

export const getPrefList = createAsyncThunk('auth/login/getPrefList', async (param) => {
});

export const getStoreRawData = createAsyncThunk('auth/login/getStoreRawData', async (param) => {
});

export const createStore = createAsyncThunk('auth/login/createStore', async (param) => {
});

export const getCategoryList = createAsyncThunk('auth/login/getCategoryList', async (param) => {
});

export const getProductOptionList = createAsyncThunk('auth/login/getProductOptionList', async (param) => {
});

export const createProductCategory = createAsyncThunk('auth/login/createProductCategory', async (param) => {
});
export const updateProductCategory = createAsyncThunk('auth/login/updateProductCategory', async (param) => {
});
export const deleteProductCategory = createAsyncThunk('auth/login/deleteProductCategory', async (param) => {
});

export const updateDisplaySequenceByCategory = createAsyncThunk('auth/login/updateDisplaySequenceByCategory', async (param) => {
});
export const updateDisplaySequenceByProduct = createAsyncThunk('auth/login/updateDisplaySequenceByProduct', async (param) => {
});
export const updateDisplaySequenceByOption = createAsyncThunk('auth/login/updateDisplaySequenceByOption', async (param) => {
});

export const createProductOption = createAsyncThunk('auth/login/createProductOption', async (param) => {
});
export const updateProductOption = createAsyncThunk('auth/login/updateProductOption', async (param) => {
});
export const deleteProductOption = createAsyncThunk('auth/login/deleteProductOption', async (param) => {
});

export const getProductListByDeveloper = createAsyncThunk('auth/login/getProductListByDeveloper', async (param) => {
});
export const createProduct = createAsyncThunk('auth/login/createProduct', async (param) => {
});
export const deleteProduct = createAsyncThunk('auth/login/deleteProduct', async (param) => {
});
export const getProduct = createAsyncThunk('auth/login/getProduct', async (param) => {
});
export const getCountProductList = createAsyncThunk('auth/login/getCountProductList', async (param) => {
});
export const deleteCountProduct = createAsyncThunk('auth/login/deleteCountProduct', async (param) => {
});
export const getPrinterIds = createAsyncThunk('auth/login/getPrinterIds', async (param) => {
});
export const updateProduct = createAsyncThunk('auth/login/updateProduct', async (param) => {
});

export const getAppSalesTime = createAsyncThunk('auth/login/getAppSalesTime', async (param) => {
});
export const updateAppSalesTime = createAsyncThunk('auth/login/updateAppSalesTime', async (param) => {
});

export const createCountProduct = createAsyncThunk('auth/login/createCountProduct', async (param) => {
});

export const updateDeveloperInvoice = createAsyncThunk('auth/login/updateDeveloperInvoice', async (param) => {
});


export const getCountProductOverview = createAsyncThunk('auth/login/getCountProductOverview', async (param) => {
});
export const getCountProductDetail = createAsyncThunk('auth/login/getCountProductDetail', async (param) => {
});


export const getSalesViewSaleMode = createAsyncThunk('auth/login/getSalesViewSaleMode', async (param) => {
});
export const updateSalesViewSaleMode = createAsyncThunk('auth/login/updateSalesViewSaleMode', async (param) => {
});
